import React, { useEffect, useState } from "react";
import { cobranzasAPI } from "../../utils/funcionesAPI";
import { manejadorDeRespuesta } from "../../utils/Tools";
import { toast } from "react-toastify";
import get from "../../utils/get";

const TarjetasBancoCuotasPedraza = (props) => {
  const [bancos, setBancos] = useState([]);
  const [tarjetas, setTarjetas] = useState([]);
  const [cuotas, setCuotas] = useState([]);
  const [bancoElegido, setBancoElegido] = useState(0);

  const { tarjetaElegida, onTarjetaClick, onBancoClick, onCuotaClick, codigoMoneda } = props;

  useEffect(() => {
    traerTarjetas();
  }, []);

  /*
  const traerBancos = () => {
    const data = JSON.stringify({ peticion: "traerBancos" });
    cobranzasAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        setBancos(respuesta.data);
      }
    });
  };
  */
  const traerBancosPorTarjeta = (idTarjeta) => {
    const data = JSON.stringify({
      peticion: "traerBancosPorTarjeta",
      idTarjeta,
    });
    cobranzasAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        setBancos(respuesta.data);
      }
    });
  };

  const traerTarjetas = () => {
    const data = JSON.stringify({ peticion: "traerTarjetasPedraza", codigoMoneda  });
    cobranzasAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        setTarjetas(respuesta.data);
      }
    });
  };

  const traerCuotas = (idTarjeta, idBanco) => {
    const pais = get(props, "producto.destino.pais", "ARG");
    const idProducto = get(props, "producto.idProducto");
    const data = JSON.stringify({
      peticion: "traerCuotasSegunBancoTarjetaProducto",
      idBanco,
      idTarjeta,
      pais,
      idProducto,
    });
    cobranzasAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        setCuotas(respuesta.data);
      }
    });
  };

  const handleTarjetaChange = (e) => {
    const tarjetaEleg = tarjetas.find(
      (tarjeta) => tarjeta.idCuentaEntidad === e.target.value
    );
    const cuotaElegida = { id: 0, interes: 0, cantidad: 0 };
    onTarjetaClick(tarjetaEleg, cuotaElegida);
    setBancoElegido(0);
    setCuotas([]);

    traerBancosPorTarjeta(tarjetaEleg.id);
  };

  const handleBancoChange = (e) => {
    if (tarjetaElegida.id === 0) {
      toast.info("Debe elegir una tarjeta primero", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    //FC: para la nueva implementacion de Prisma tengo que mandar el banco completo
    const bancoSelected = bancos.find((b) => b.id === e.target.value);
    const cuotaElegida = { id: 0, interes: 0, cantidad: 0 };
    onTarjetaClick(tarjetaElegida, cuotaElegida);
    onBancoClick(bancoSelected);

    setBancoElegido(e.target.value);

    traerCuotas(tarjetaElegida.id, e.target.value);
  };

  const handleCuotaChange = (e) => {
    const cuotaEleg = cuotas.find((cuota) => cuota.id === e.target.value);
    onCuotaClick(cuotaEleg);

    //const subTotalImporteMasImpuesto = parseFloat(this.state.importeAPagar) + parseFloat(this.state.importeProporcionalRGPais);
    //const nuevoImporteAPagar = subTotalImporteMasImpuesto + parseFloat(( subTotalImporteMasImpuesto * cuotaEleg.interes / 100)) ;
    //this.setState({cuotaElegida: cuotaEleg, importeAPagarConImpuestosYIntereses: nuevoImporteAPagar});
  };

  return (
    <div
      style={{ padding: "0" }}
      className="input-container col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 datos-personales"
    >
      <div className="fieldset row bg">
        <div className="select-container" style={{ width: "100%" }}>
          <label
            style={{ marginTop: "10px", display: "block", marginLeft: "5px" }}
            className="labelForm text-left"
          >
            Seleccionar Tarjeta de Crédito
          </label>
          <select
            className="selectPagoConTarjeta form-control"
            name="tarjeta"
            id="tarjeta"
            onChange={handleTarjetaChange}
          >
            <option value="0">Seleccionar Tarjeta</option>
            {tarjetas.map((tarjeta) => {
              return (
                <option key={tarjeta.idCuentaEntidad} value={tarjeta.idCuentaEntidad}>
                  {tarjeta.denominacion} ({tarjeta.codigoMoneda})
                </option>
              );
            })}
          </select>
        </div>
        <div className="select-container" style={{ width: "100%" }}>
          <label
            style={{ marginTop: "10px", display: "block", marginLeft: "5px" }}
            className="labelForm text-left labelForm"
          >
            Seleccionar Banco Emisor
          </label>
          <select
            className="selectPagoConTarjeta form-control"
            value={bancoElegido}
            name="banco"
            id="banco"
            onChange={handleBancoChange}
          >
            <option value="0">Seleccionar Banco Emisor</option>
            {bancos.map((banco) => {
              return (
                <option key={banco.id} value={banco.id}>
                  {banco.denominacion}
                </option>
              );
            })}
          </select>
        </div>
        <div className="select-container" style={{ width: "100%" }}>
          <label
            style={{ marginTop: "10px", display: "block", marginLeft: "5px" }}
            className="labelForm text-left"
          >
            Seleccionar Plan de Cuotas
          </label>
          <select
            className="selectPagoConTarjeta form-control"
            name="cuotas"
            id="cuotas"
            onChange={handleCuotaChange}
          >
            <option value="0">Seleccionar Cuotas</option>
            {cuotas.map((cuota) => {
              return (
                <option key={cuota.id} value={cuota.id}>
                  {cuota.descripcion}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </div>
  );
};

export default TarjetasBancoCuotasPedraza;



// WEBPACK FOOTER //
// ./src/components/Global/TarjetasBancoCuotasPedraza.js